import { Link } from 'react-router-dom';
import { Button, PublicShell } from '@kmgestao/ui';

import { Brand } from '../../components/Brand.js';

export function NotFoundPage() {
  return (
    <PublicShell brand={<Brand />}>
      <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
        <p className="text-sm font-medium text-muted-foreground">Erro 404</p>
        <h1 className="text-3xl font-semibold tracking-tight">Página não encontrada</h1>
        <p className="max-w-md text-sm text-muted-foreground">
          O endereço que você acessou não existe ou foi removido. Volte para o começo para continuar
          navegando.
        </p>
        <Button asChild>
          <Link to="/">Ir para o início</Link>
        </Button>
      </div>
    </PublicShell>
  );
}
